__turbopack_context__.v({
  "order-selector": "index-module-scss-module__e2VQDW__order-selector",
});
